import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxpaxselector';
export const route = 'cnxpaxselector/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxpaxselector" */
/* webpackPrefetch: true */
'../components/PaxSelectorPage')));